import { render, staticRenderFns } from "./LevelLeft.vue?vue&type=template&id=1d1fd49c&"
import script from "./LevelLeft.vue?vue&type=script&lang=js&"
export * from "./LevelLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports